import SearchPagination from './SearchPagination';

export { type SearchPaginationProps } from './SearchPagination';
export default SearchPagination;
